/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimTask
 */
export interface ClaimTask {
    /**
     * 
     * @type {any}
     * @memberof ClaimTask
     */
    taskId: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimTask
     */
    taskType: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimTask
     */
    status: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTask
     */
    targetDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimTask
     */
    assigned: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimTask
     */
    onHoldUntil: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimTask
     */
    holdDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimTask
     */
    onHoldStatus: string | null;
}

/**
 * Check if a given object implements the ClaimTask interface.
 */
export function instanceOfClaimTask(value: object): value is ClaimTask {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('targetDate' in value) || value['targetDate'] === undefined) return false;
    if (!('assigned' in value) || value['assigned'] === undefined) return false;
    if (!('onHoldUntil' in value) || value['onHoldUntil'] === undefined) return false;
    if (!('holdDescription' in value) || value['holdDescription'] === undefined) return false;
    if (!('onHoldStatus' in value) || value['onHoldStatus'] === undefined) return false;
    return true;
}

export function ClaimTaskFromJSON(json: any): ClaimTask {
    return ClaimTaskFromJSONTyped(json, false);
}

export function ClaimTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimTask {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'taskType': json['taskType'],
        'status': json['status'],
        'targetDate': (new Date(json['targetDate'])),
        'assigned': json['assigned'],
        'onHoldUntil': (new Date(json['onHoldUntil'])),
        'holdDescription': json['holdDescription'],
        'onHoldStatus': json['onHoldStatus'],
    };
}

export function ClaimTaskToJSON(value?: ClaimTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'taskId': value['taskId'],
        'taskType': value['taskType'],
        'status': value['status'],
        'targetDate': ((value['targetDate']).toISOString().substring(0,10)),
        'assigned': value['assigned'],
        'onHoldUntil': ((value['onHoldUntil']).toISOString().substring(0,10)),
        'holdDescription': value['holdDescription'],
        'onHoldStatus': value['onHoldStatus'],
    };
}

